import styled from 'styled-components';

export const StatisticsList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;
export const StatisticsItem = styled.li`
  font-size: 28px;
  letter-spacing: 2px;
  font-weight: 600;
`;
export const StatisticsSpan = styled.span`
  background: #f0efef;
  color: #034f84;
  padding: 0 10px;
  border-radius: 5px;
`;
